import ServiceException from '@ch-types/CoralExceptionTypes/ServiceException';

export default class InternalServiceError extends ServiceException {}
